import mock from "src/mock/mock_bolepix_new.json";

export const mockData = (
  data: CheckoutType | undefined,
  { isUseMockData }: { isUseMockData: boolean },
) => {
  if (isUseMockData) {
    return mock as unknown as CheckoutType;
  }
  return data;
};
